import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  open: {
    method: 'POST',
    url: `${configs.baseUrl}/api/help-modal/open`,
  },
  getState: {
    method: 'GET',
    url: `${configs.baseUrl}/api/help-modal/state`,
  },
  joinQuest: {
    method: 'POST',
    url: `${configs.baseUrl}/api/me/quests/{questId}/join`,
  },
  confirmTask: {
    method: 'POST',
    url: `${configs.baseUrl}/api/me/quests/{questId}/confirm-task`,
  },
  abandonQuest: {
    method: 'POST',
    url: `${configs.baseUrl}/api/me/quests/{questId}/abandon`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const open = async () => {
  const res = await resource.open({}, {})
  return res.body
}

const getState = async () => {
  const res = await resource.getState()
  return res.body
}

const joinQuest = async (questId) => {
  const res = await resource.joinQuest({ questId }, {})
  return res.body
}

const confirmTask = async (questId, taskId) => {
  const res = await resource.confirmTask({ questId }, { taskId })
  return res.body
}

const abandonQuest = async (questId) => {
  const res = await resource.abandonQuest({ questId }, {})
  return res.body
}

export default {
  initResource,
  open,
  getState,
  joinQuest,
  confirmTask,
  abandonQuest,
}
